// Shared key-naming helper for every per-user Global Search localStorage
// store (recentSearchStore.js, recentlyViewedStore.js, favoritesStore.js,
// diagnosticTipStore.js). Each store scopes its own key under
// `globalSearch.<thing>.<companyDomain>.<userId>` so a shared/public browser
// never leaks one person's data to whoever logs in next on the same
// machine - this file is the single place that computes the
// `<companyDomain>.<userId>` suffix so the four stores don't each
// reimplement the same lookup.
export const getGlobalSearchKeySuffix = () => {
  try {
    const companySlug = localStorage.getItem("companyDomain") || "unknown-company";
    const userData = JSON.parse(localStorage.getItem("user_data") || "null");
    const userId = userData?._id || "unknown-user";
    return `${companySlug}.${userId}`;
  } catch (e) {
    return "unknown";
  }
};

// The "<thing>" segment of every Global Search store's key - kept in one
// place so clearGlobalSearchStorageForCurrentUser below always stays in
// sync with the four store files.
const GLOBAL_SEARCH_KEY_NAMES = [
  "recent",
  "recentlyViewed",
  "favorites",
  "diagnosticTipSeenCount",
];

// Removes every Global-Search-related localStorage key for whichever user
// is CURRENTLY logged in (computed from the still-present companyDomain /
// user_data keys), so a shared/public browser doesn't retain the previous
// user's recent searches, recently-viewed records, favorites, or
// diagnostic-tip state after they log out. Must be called before
// `user_data`/`companyDomain` themselves are cleared from localStorage,
// since the suffix above needs them to compute which key belongs to this
// user. Safe to call even if storage is unavailable (private browsing) -
// every other store in this module follows the same fail-soft convention.
export const clearGlobalSearchStorageForCurrentUser = () => {
  try {
    const suffix = getGlobalSearchKeySuffix();
    GLOBAL_SEARCH_KEY_NAMES.forEach((name) => {
      localStorage.removeItem(`globalSearch.${name}.${suffix}`);
    });
  } catch (e) {
    // Private browsing / storage blocked - nothing to clear anyway.
  }
};
